export const externalAccountsEn = {
  // Page heading and titles
  'external-accounts-heading': 'Contacts',
  'external-accounts-list-title': 'Contacts',

  // Type filter options
  'external-accounts-type-all': 'All Types',
  'external-accounts-type-push': 'Interac e-Transfer Push',
  'external-accounts-type-pull': 'Interac e-Transfer Pull',
  'external-accounts-type-visa-direct': 'Debit Card - Push',
  'external-accounts-type-interac': 'Debit Card - Pull',
  'external-accounts-type-label': 'Contact Type',
  'external-accounts-type-filter-label': 'Filter by type:',

  // Buttons
  'external-accounts-add-button': 'Add Contact',
  'external-accounts-edit-button': 'Edit Contact',
  'external-accounts-delete-button': 'Delete Contact',
  'external-accounts-view-transfers-button': 'View Transfers',

  // Modal headings
  'external-accounts-add-heading': 'Add Contact',
  'external-accounts-edit-heading': 'Edit Contact',

  // Form labels
  'external-accounts-contact-name-input-label': 'Contact Name',
  'external-accounts-contact-first-name-input-label': 'First Name',
  'external-accounts-contact-last-name-input-label': 'Last Name',
  'external-accounts-contact-email-input-label': 'Email',
  'external-accounts-contact-confirm-email-input-label': 'Confirm Email',
  // Debit card form labels
  'external-accounts-cardholder-name-input-label': 'Cardholder Name',
  'external-accounts-card-number-input-label': 'Card Number',
  'external-accounts-card-expiry-input-label': 'Expiry (MM/YYYY)',
  'external-accounts-card-cvv-input-label': 'CVV',
  'external-accounts-card-noCvvNeeded': 'No CVV needed.',
  'external-accounts-address-line1-input-label': 'Address Line 1',
  'external-accounts-address-line2-input-label': 'Address Line 2',
  'external-accounts-city-input-label': 'City',
  'external-accounts-state-input-label': 'Province/State',
  'external-accounts-postal-code-input-label': 'Postal/Zip Code',
  'external-accounts-country-input-label': 'Country',

  // Success alerts
  'external-accounts-add-success-alert': 'Contact added successfully',
  'external-accounts-update-success-alert': 'Contact updated successfully',
  'external-accounts-account-deleted-alert': 'Contact deleted successfully',

  // Error alerts
  'external-accounts-fetch-error': 'Failed to load contact details',
  'external-accounts-create-failed-error': 'Failed to create Contact',
  'external-accounts-update-failed-error': 'Failed to update Contact',
  'external-accounts-delete-error-alert': 'Failed to delete Contact',
  'external-accounts-emails-mismatch-error': 'Emails do not match.',

  // Info alerts
  'external-accounts-no-accounts-alert': 'No Contacts found.',

  // Delete confirmation
  'external-accounts-delete-heading': 'Confirm Delete',
  'external-accounts-delete-form-text': 'Are you sure you want to delete <b>{name}</b>?',

  // ========================================
  // Contact Details Page
  // ========================================
  'external-account-details-heading': 'Contact Details',
  'external-account-details-title': 'Contact',
  'external-account-details-back-button': 'Back to Contacts',
  'external-account-details-edit-button': 'Edit Contact',
  'external-account-details-delete-button': 'Delete Contact',

  // Detail labels
  'external-account-details-name-label': 'Name',
  'external-account-details-contact-name-label': 'Contact Name',
  'external-account-details-email-label': 'Email',
  'external-account-details-phone-label': 'Phone',
  'external-account-details-type-label': 'Type',
  'external-account-details-status-label': 'Status',
  'external-account-details-created-label': 'Created',
  'external-account-details-updated-label': 'Last Updated',
  // Card detail labels
  'external-account-details-cardholder-name-label': 'Cardholder Name',
  'external-account-details-card-number-label': 'Card Number',
  'external-account-details-card-expiry-label': 'Expiry Date',
  'external-account-details-address-label': 'Address',

  // Transfers section
  'external-account-details-transfers-title': 'Transfers',
  'external-account-details-no-transfers-alert': 'No transfers found for this contact.',

  // Table headers
  'external-account-details-date-table-header': 'Date',
  'external-account-details-type-table-header': 'Type',
  'external-account-details-status-table-header': 'Status',
  'external-account-details-amount-table-header': 'Amount',
  'external-account-details-action-table-header': 'Action',

  // Cancel transfer modal
  'external-account-details-cancel-heading': 'Cancel Transfer',
  'external-account-details-cancel-confirm-text': 'Are you sure you want to cancel this transfer? This action cannot be undone.',
  'external-account-details-confirm-cancel-button': 'Yes, Cancel Transfer',
  'external-account-details-keep-button': 'No, Keep Transfer',
  'external-account-details-cancel-success-alert': 'Transfer cancelled successfully',
  'external-account-details-cancel-error-alert': 'Failed to cancel transfer. Please email Cardholder Support for more information.',

  // Error alerts
  'external-account-details-not-found-alert': 'Contact not found',
  'external-account-details-delete-error-alert': 'Failed to delete Contact',

  // Delete confirmation modal
  'external-account-details-delete-heading': 'Confirm Delete',
  'external-account-details-delete-form-text': 'Are you sure you want to delete <b>{name}</b>?',

  // ========================================
  // Contact Transfers Page
  // ========================================
  'external-account-transfers-heading': 'Transfers',
  'external-account-transfers-list-title': 'Transfers',
  'external-account-transfers-back-button': 'Back to Contact',
  'external-account-transfers-no-transfers-alert': 'No transfers found for this contact.',

  // Table headers
  'external-account-transfers-date-table-header': 'Date',
  'external-account-transfers-type-table-header': 'Type',
  'external-account-transfers-status-table-header': 'Status',
  'external-account-transfers-amount-table-header': 'Amount',
  'external-account-transfers-action-table-header': 'Action',

  // Cancel transfer modal
  'external-account-transfers-cancel-heading': 'Cancel Transfer',
  'external-account-transfers-cancel-confirm-text': 'Are you sure you want to cancel this transfer? This action cannot be undone.',
  'external-account-transfers-confirm-cancel-button': 'Yes, Cancel Transfer',
  'external-account-transfers-keep-button': 'No, Keep Transfer',
  'external-account-transfers-cancel-success-alert': 'Transfer cancelled successfully',
  'external-account-transfers-cancel-error-alert': 'Failed to cancel transfer. Please email Cardholder Support for more information.',
};

export const externalAccountsFr = {
  // Page heading and titles
  'external-accounts-heading': 'Contacts',
  'external-accounts-list-title': 'Contacts',

  // Type filter options
  'external-accounts-type-all': 'Tous les types',
  'external-accounts-type-push': 'Virement Interac sortant',
  'external-accounts-type-pull': 'Virement Interac entrant',
  'external-accounts-type-visa-direct': 'Carte de débit - Sortant',
  'external-accounts-type-interac': 'Carte de débit - Entrant',
  'external-accounts-type-label': 'Type de contact',
  'external-accounts-type-filter-label': 'Filtrer par type:',

  // Buttons
  'external-accounts-add-button': 'Ajouter un contact',
  'external-accounts-edit-button': 'Modifier le contact',
  'external-accounts-delete-button': 'Supprimer le contact',
  'external-accounts-view-transfers-button': 'Voir les transferts',

  // Modal headings
  'external-accounts-add-heading': 'Ajouter un contact',
  'external-accounts-edit-heading': 'Modifier le contact',

  // Form labels
  'external-accounts-contact-name-input-label': 'Nom du contact',
  'external-accounts-contact-first-name-input-label': 'Prénom',
  'external-accounts-contact-last-name-input-label': 'Nom de famille',
  'external-accounts-contact-email-input-label': 'Courriel',
  'external-accounts-contact-confirm-email-input-label': 'Confirmer le courriel',
  // Debit card form labels
  'external-accounts-cardholder-name-input-label': 'Nom du titulaire',
  'external-accounts-card-number-input-label': 'Numéro de carte',
  'external-accounts-card-expiry-input-label': 'Expiration (MM/AAAA)',
  'external-accounts-card-cvv-input-label': 'CVV',
  'external-accounts-card-noCvvNeeded': 'Aucun CVV requis.',
  'external-accounts-address-line1-input-label': 'Adresse ligne 1',
  'external-accounts-address-line2-input-label': 'Adresse ligne 2',
  'external-accounts-city-input-label': 'Ville',
  'external-accounts-state-input-label': 'Province/État',
  'external-accounts-postal-code-input-label': 'Code postal/ZIP',
  'external-accounts-country-input-label': 'Pays',

  // Success alerts
  'external-accounts-add-success-alert': 'Contact ajouté avec succès',
  'external-accounts-update-success-alert': 'Contact mis à jour avec succès',
  'external-accounts-account-deleted-alert': 'Contact supprimé avec succès',

  // Error alerts
  'external-accounts-fetch-error': 'Échec du chargement des détails du contact',
  'external-accounts-create-failed-error': 'Échec de la création du contact',
  'external-accounts-update-failed-error': 'Échec de la mise à jour du contact',
  'external-accounts-delete-error-alert': 'Échec de la suppression du contact',
  'external-accounts-emails-mismatch-error': 'Les courriels ne correspondent pas.',

  // Info alerts
  'external-accounts-no-accounts-alert': 'Aucun contact trouvé.',

  // Delete confirmation
  'external-accounts-delete-heading': 'Confirmer la suppression',
  'external-accounts-delete-form-text': 'Êtes-vous sûr de vouloir supprimer <b>{name}</b>?',

  // ========================================
  // Contact Details Page
  // ========================================
  'external-account-details-heading': 'Détails du contact',
  'external-account-details-title': 'Contact',
  'external-account-details-back-button': 'Retour aux contacts',
  'external-account-details-edit-button': 'Modifier le contact',
  'external-account-details-delete-button': 'Supprimer le contact',

  // Detail labels
  'external-account-details-name-label': 'Nom',
  'external-account-details-contact-name-label': 'Nom du contact',
  'external-account-details-email-label': 'Courriel',
  'external-account-details-phone-label': 'Téléphone',
  'external-account-details-type-label': 'Type',
  'external-account-details-status-label': 'Statut',
  'external-account-details-created-label': 'Créé',
  'external-account-details-updated-label': 'Dernière mise à jour',
  // Card detail labels
  'external-account-details-cardholder-name-label': 'Nom du titulaire',
  'external-account-details-card-number-label': 'Numéro de carte',
  'external-account-details-card-expiry-label': 'Date d\'expiration',
  'external-account-details-address-label': 'Adresse',

  // Transfers section
  'external-account-details-transfers-title': 'Transferts',
  'external-account-details-no-transfers-alert': 'Aucun transfert trouvé pour ce contact.',

  // Table headers
  'external-account-details-date-table-header': 'Date',
  'external-account-details-type-table-header': 'Type',
  'external-account-details-status-table-header': 'Statut',
  'external-account-details-amount-table-header': 'Montant',
  'external-account-details-action-table-header': 'Action',

  // Cancel transfer modal
  'external-account-details-cancel-heading': 'Annuler le transfert',
  'external-account-details-cancel-confirm-text': 'Êtes-vous sûr de vouloir annuler ce transfert? Cette action est irréversible.',
  'external-account-details-confirm-cancel-button': 'Oui, annuler le transfert',
  'external-account-details-keep-button': 'Non, conserver le transfert',
  'external-account-details-cancel-success-alert': 'Transfert annulé avec succès',
  'external-account-details-cancel-error-alert': 'Échec de l\'annulation du transfert. Veuillez envoyer un courriel au service d\'assistance aux titulaires de carte pour plus d\'informations.',

  // Error alerts
  'external-account-details-not-found-alert': 'Contact introuvable',
  'external-account-details-delete-error-alert': 'Échec de la suppression du contact',

  // Delete confirmation modal
  'external-account-details-delete-heading': 'Confirmer la suppression',
  'external-account-details-delete-form-text': 'Êtes-vous sûr de vouloir supprimer <b>{name}</b>?',

  // ========================================
  // Contact Transfers Page
  // ========================================
  'external-account-transfers-heading': 'Transferts',
  'external-account-transfers-list-title': 'Transferts',
  'external-account-transfers-back-button': 'Retour au contact',
  'external-account-transfers-no-transfers-alert': 'Aucun transfert trouvé pour ce contact.',

  // Table headers
  'external-account-transfers-date-table-header': 'Date',
  'external-account-transfers-type-table-header': 'Type',
  'external-account-transfers-status-table-header': 'Statut',
  'external-account-transfers-amount-table-header': 'Montant',
  'external-account-transfers-action-table-header': 'Action',

  // Cancel transfer modal
  'external-account-transfers-cancel-heading': 'Annuler le transfert',
  'external-account-transfers-cancel-confirm-text': 'Êtes-vous sûr de vouloir annuler ce transfert? Cette action est irréversible.',
  'external-account-transfers-confirm-cancel-button': 'Oui, annuler le transfert',
  'external-account-transfers-keep-button': 'Non, conserver le transfert',
  'external-account-transfers-cancel-success-alert': 'Transfert annulé avec succès',
  'external-account-transfers-cancel-error-alert': 'Échec de l\'annulation du transfert. Veuillez envoyer un courriel au service d\'assistance aux titulaires de carte pour plus d\'informations.',
};
